import { useRef } from "react";
import { motion, useScroll, useTransform, MotionValue } from "framer-motion";
import { cn } from "@/lib/utils";

interface ParallaxImageProps {
    src: string;
    alt: string;
    className?: string;
    speed?: number; // -1 to 1 preferably
}

function useParallax(value: MotionValue<number>, distance: number) {
    return useTransform(value, [0, 1], [-distance, distance]);
}

const ParallaxImage = ({ src, alt, className, speed = 100 }: ParallaxImageProps) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref });
    const y = useParallax(scrollYProgress, speed);

    return (
        <div ref={ref} className={cn("overflow-hidden relative", className)}>
            <motion.img
                src={src}
                alt={alt}
                style={{ y, scale: 1.2 }} // Scale up to check white gaps
                className="w-full h-full object-cover"
            />
        </div>
    );
};

export default ParallaxImage;
